import axios from "axios";
import { API_TIALAI, API_TIMEOUT } from "utils";

const api = axios.create({
  baseURL: API_TIALAI,
  timeout: API_TIMEOUT,
});

api.interceptors.request.use((config) => {
  const raw = localStorage.getItem("user");
  if (raw) {
    try {
      const user = JSON.parse(raw);
      if (user.token) {
        config.headers.Authorization = `Bearer ${user.token}`;
      }
    } catch (_) {
      /* ignore */
    }
  }
  return config;
});

export default api;

export const getDashboardPath = (role) => {
  switch (role) {
    case "PEMOHON":
      return "/dashboard/pemohon";
    case "PETUGAS":
    case "VERIFIKATOR":
    case "PIMPINAN":
      return "/dashboard/petugas";
    case "ADMIN":
    case "SUPER_ADMIN":
      return "/dashboard/admin";
    default:
      return "/authentication/sign-in/cover";
  }
};
